var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 509.381 509.381",
    height: 512,
    viewBox: "0 0 509.381 509.381",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m462.793 127.236h-6.338v-61.55c0-25.688-20.899-46.588-46.588-46.588h-337.904c-37.288 0-68.032 28.521-71.581 64.892-.542 2.57-.349-20.33-.349 334.363 0 39.662 32.267 71.929 71.929 71.929h390.83c25.689 0 46.588-20.899 46.588-46.588v-269.87c.001-25.688-20.898-46.588-46.587-46.588zm-390.83-76.137h337.904c8.044 0 14.588 6.544 14.588 14.588v61.55h-352.492c-21.393 0-38.906-16.913-39.882-38.069.975-21.157 18.488-38.069 39.882-38.069zm390.83 407.183h-390.83c-22.017 0-39.929-17.912-39.929-39.929v-271.243c11.431 7.657 25.167 12.126 39.929 12.126h390.83c8.044 0 14.588 6.544 14.588 14.588v64.866h-120.408c-41.007 0-74.369 33.361-74.369 74.368s33.362 74.368 74.369 74.368h120.408v56.268c0 8.044-6.544 14.588-14.588 14.588zm14.588-102.855h-120.408c-23.362 0-42.369-19.006-42.369-42.368s19.006-42.368 42.369-42.368h120.408z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 362.878,
    cy: 313.059,
    r: 23.188
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.144f93e7.svg";
export { ForwardRef as ReactComponent };